import { z } from 'zod';
/**
 * Path parameters the endpoints addressing one run accept: re-run, resume, cancel and status.
 *
 * Named for what it carries rather than for any one of them, since they all carry the same thing.
 */
export const FlowRunIdParamsSchema = z.object({
    flowRunId: z.uuid().describe('The flow run.'),
});
/** Path parameters the endpoints addressing one block of one run accept. */
export const FlowRunBlockParamsSchema = FlowRunIdParamsSchema.extend({
    blockId: z.string().describe('The block id within the flow definition.'),
});
//# sourceMappingURL=params.js.map